import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from '../../../core/http/api-client.service';
import {
  CompanyRetentionPolicyDto,
  DataRetentionPoliciesDto,
  DataRetentionRunSummaryDto,
  GlobalRetentionPolicyDto,
  UpdateCompanyRetentionPolicyRequest,
  UpdateGlobalRetentionPolicyRequest,
} from './data-retention.models';

@Injectable({
  providedIn: 'root'
})
export class DataRetentionService {
  private readonly apiClient = inject(ApiClientService);

  public getPolicies(): Observable<DataRetentionPoliciesDto> {
    return this.apiClient.get<DataRetentionPoliciesDto>('/data-retention/policies');
  }

  public updateGlobalPolicy(
    payload: UpdateGlobalRetentionPolicyRequest,
  ): Observable<GlobalRetentionPolicyDto> {
    return this.apiClient.patch<GlobalRetentionPolicyDto, UpdateGlobalRetentionPolicyRequest>(
      '/data-retention/policies/global',
      payload,
    );
  }

  public updateCompanyPolicy(
    companyId: string,
    payload: UpdateCompanyRetentionPolicyRequest,
  ): Observable<CompanyRetentionPolicyDto> {
    return this.apiClient.patch<CompanyRetentionPolicyDto, UpdateCompanyRetentionPolicyRequest>(
      `/data-retention/policies/company/${companyId}`,
      payload,
    );
  }

  public runCompanyRetention(companyId: string): Observable<DataRetentionRunSummaryDto> {
    return this.apiClient.post<DataRetentionRunSummaryDto, null>(
      `/data-retention/runs/company/${companyId}`,
      null,
    );
  }
}
